module.exports = __webpack_public_path__ + "media/10 aroma.7a0ac748.mp3";